module.exports = __webpack_public_path__ + "img/header-weddingRingsWomen.8acd5cf.webp";